const data = {
  fastcompany: {
    logo:
      '//a.fastcompany.net/image/upload/v1488299125/fc/fastcompany-logo.svg',
    title: 'Fast Company',
    subscribeLink: 'https://www.fastcompany.com/combo',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [
      {
        url: '/co-design',
        title: 'Co.Design'
      },
      {
        url: '/technology',
        title: 'Tech'
      },
      {
        url: '/work-life',
        title: 'Work Life'
      },
      {
        url: '/creativity',
        title: 'Creativity'
      },
      {
        url: '/impact',
        title: 'Impact'
      },
      {
        url: '/section/podcasts',
        title: 'Podcasts'
      },
      {
        url: '/videos',
        title: 'Video'
      },
      {
        url: '/news',
        title: 'News'
      },
      {
        url: '/recommender',
        title: 'Recommender',
        removeOnScale: true
      },
      {
        url: 'https://magazine.fastcompany.com/loc/FST/topnav1999',
        title: 'Subscribe',
        external: true,
        // removeOnScale: true,
        bold: true,
        subtopics: [
          {
            title: 'Newsletters',
            url: '/newsletters'
          },
          {
            title: 'Magazine',
            external: true,
            url:
              'https://magazine.fastcompany.com/pubs/FC/FST/order_page_0618.jsp?cds_page_id=227542&cds_mag_code=FST&id=1572899020925&lsid=93081411311039891&vid=2&cds_response_key=IB8AFEEX4'
          },
          {
            title: 'Podcasts',
            external: true,
            url: 'https://podcasts.apple.com/us/artist/fast-company/1393767793'
          }
        ]
      }
    ],
    channels: [
      {
        logo: '',
        title: 'FastCo Works',
        items: [
          {
            url: '/brandworks/att',
            title: 'AT&T'
          },
          {
            url: '/brandworks/cummins',
            title: 'Cummins'
          },
          {
            url: '/brandworks/SAP',
            title: 'SAP'
          },
          {
            url: '/brandworks/staples',
            title: 'Staples'
          }
        ]
      }
    ]
  }
};

export default data;
